var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
var {Dropdown} = require('ui-library');
var moment = require('moment');

var DatePicker = require('./date-picker.jsx');
var HourPicker = require('./hour-picker.jsx');

var DateDropdown = createClass({

  propTypes: {
    size: PropTypes.string,

    selectedDate: PropTypes.any,
    minDate: PropTypes.any,
    maxDate: PropTypes.any,
    onChange: PropTypes.func,

    selectHour: PropTypes.bool,

    noDateMessage: PropTypes.string,
    predefinedDays: PropTypes.array
  },

  getDefaultProps() {
    return {
      selectHour: false,
      noDateMessage: 'No se ha seleccionado fecha'
    };
  },

  setDateDaysFromNow(days) {
    const selectedDate = moment().add(days, 'day');
    this.props.onChange(selectedDate);
  },

  getPredefinedOptions() {
    const {predefinedDays} = this.props;
    if (!predefinedDays) return null;
    const elements = predefinedDays.map(element => {
      return <a className='vf-link padding-right-1x' onClick={this.setDateDaysFromNow.bind(null, element.days)}>{element.label}</a>;
    });
    return (
      <div className='flex flex-start padding-top-1x'>
        {elements}
      </div>
    );
  },

  render() {
    var {size, selectedDate, minDate, maxDate, onChange, selectHour, noDateMessage} = this.props;

    var dropdownTitle = selectedDate ? moment(selectedDate).format('DD/MMM/YY') + (selectHour ? '   ' + moment(selectedDate).format('HH:mm') : '') : noDateMessage;
    var displayDate = selectedDate ? moment(selectedDate).toDate() : moment().toDate();

    return (
      <Dropdown title={dropdownTitle} size={size} className='day-dropdown-button'>
        <div className='padding-2x day-picker-container'>
            <DatePicker selectedDate={displayDate} minDate={minDate} maxDate={maxDate} onChange={onChange}/>
            {selectHour && (
              <div className='padding-top-1x'>
                <HourPicker date={displayDate} onChange={onChange} />
              </div>
            )}
            {this.getPredefinedOptions()}
        </div>
      </Dropdown>
    );
  }

});

module.exports = DateDropdown;
